import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, Suspense, useCallback, useContext, useEffect, useLayoutEffect, useMemo, useState } from "react";
const suspenseContext = createContext(undefined);
const globalSuspenseContext = createContext(undefined);
export function GlobalSuspenseProvider(props) {
    const { children, fallback, replace = false } = props;
    const [activeCounter, setActiveCounter] = useState(0);
    const [overriddenCounter, setOverriddenCounter] = useState(0);
    const activate = useCallback(() => {
        setActiveCounter(s => s + 1);
        return () => setActiveCounter(s => s - 1);
    }, []);
    const override = useCallback(() => {
        setOverriddenCounter(s => s + 1);
        return () => setOverriddenCounter(s => s - 1);
    }, []);
    window.dployUI = window.dployUI ?? {};
    window.dployUI.globalSuspense = {
        activate: window.dployUI.globalSuspense?.activate ?? activate,
        override: window.dployUI.globalSuspense?.override ?? override
    };
    const globalSuspense = useContext(globalSuspenseContext);
    const active = globalSuspense?.active ?? activeCounter > 0;
    const suspense = useContext(suspenseContext);
    useEffect(() => globalSuspense?.override(), [globalSuspense]);
    const suspenseValue = useMemo(() => ({ activate: window?.dployUI?.globalSuspense?.activate ?? activate }), [window.dployUI.globalSuspense.activate]);
    const globalSuspenseValue = useMemo(() => ({
        override: window?.dployUI?.globalSuspense?.override ?? override,
        active
    }), [active, window.dployUI.globalSuspense.override]);
    return (_jsx(suspenseContext.Provider, { value: suspense ?? suspenseValue, children: _jsxs(globalSuspenseContext.Provider, { value: globalSuspenseValue, children: [active && overriddenCounter === 0 ? fallback : null, _jsx(GlobalSuspense, { children: active && replace ? null : children })] }) }));
}
export function GlobalSuspenseActivator() {
    const suspense = useContext(suspenseContext);
    useLayoutEffect(() => {
        const activateCallback = suspense?.activate ?? window.dployUI?.globalSuspense?.activate;
        const cleanup = activateCallback?.();
        return () => cleanup?.();
    }, [suspense]);
    return null;
}
export function useGlobalSuspenseIsLoading() {
    const ctx = useContext(globalSuspenseContext);
    return ctx?.active ?? false;
}
export function GlobalSuspense(props) {
    return _jsx(Suspense, { fallback: _jsx(GlobalSuspenseActivator, {}), ...props });
}
//# sourceMappingURL=GlobalSuspense.js.map